import { PayoutState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { createHandler } from '@mews/std';
import { Tag, TagVariant } from '@optimus-web/core';
import { PAYOUT_STATE_TEXT_KEY_MAP } from '../textKeyMaps';

const getTagVariantFromPayoutState = createHandler<PayoutState, TagVariant>({
    [PayoutState.Paid]: 'success',
    [PayoutState.Pending]: 'info',
    [PayoutState.Failed]: 'danger',
});

export const PayoutStateTag = ({ state }: { state: PayoutState }) => {
    const tagVariant = getTagVariantFromPayoutState(state);

    return (
        <Tag variant={tagVariant} data-test-payout-state-tag={state}>
            <LocalizedText textKey={PAYOUT_STATE_TEXT_KEY_MAP[state]} />
        </Tag>
    );
};
